import Vuex from 'vuex'
import Vue from 'vue'
import createPersistedState from 'vuex-persistedstate'
import auth from './modules/auth'
import b122Table from './modules/b122Table'
import brand from "./modules/brand";
import unsavedChangesStore from './modules/unsavedChangesStore'
import store from './modules/store'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    b122Table,
    unsavedChangesStore,
    store,
    brand
  },
  plugins: [
    createPersistedState({
      paths: ['auth', 'b122Table', 'unsavedChangesStore', 'store','brand']
    })
  ]
})




// WEBPACK FOOTER //
// ./src/store/index.js